export enum YoungRegistrationState {
  NOT_REGISTERED = 'NOT_REGISTERED',
  REGISTERED = 'REGISTERED',
  SELECTED = 'SELECTED',
  NOT_SELECTED = 'NOT_SELECTED',
  REFUSED = 'REFUSED',
  EXCLUDED = 'EXCLUDED',
  CONFIRMED = 'CONFIRMED',
  WAITING = 'WAITING',
  GAVE_UP = 'GAVE_UP',
}

export const YoungRegistrationStateOptions = [
  { id: YoungRegistrationState.NOT_REGISTERED, label: 'app.YoungRegistrationState.NOT_REGISTERED' },
  { id: YoungRegistrationState.REGISTERED, label: 'app.YoungRegistrationState.REGISTERED' },
  { id: YoungRegistrationState.SELECTED, label: 'app.YoungRegistrationState.SELECTED' },
  { id: YoungRegistrationState.NOT_SELECTED, label: 'app.YoungRegistrationState.NOT_SELECTED' },
  { id: YoungRegistrationState.REFUSED, label: 'app.YoungRegistrationState.REFUSED' },
  { id: YoungRegistrationState.EXCLUDED, label: 'app.YoungRegistrationState.EXCLUDED' },
  { id: YoungRegistrationState.CONFIRMED, label: 'app.YoungRegistrationState.CONFIRMED' },
  { id: YoungRegistrationState.WAITING, label: 'app.YoungRegistrationState.WAITING' },
  { id: YoungRegistrationState.GAVE_UP, label: 'app.YoungRegistrationState.GAVE_UP' },
];
